import { Text } from "./Text";
import { Section } from "./Section";
import { Column } from "./Column";
import { Button } from "./Button";
import { Divider } from "./Divider";
import { Group } from "./Group";
import { Hero } from "./Hero";
import { Image } from "./Image";
import { Navbar } from "./Navbar";
import { NavbarLink } from "./NavbarLink";
import { Social } from "./Social";
import { SocialElement } from "./SocialElement";
import { Spacer } from "./Spacer";
import { Raw } from "./Raw";
import { Table } from "./Table";

export const ElementAllowAttributes = {
  Text: Text,
  Section: Section,
  Column: Column,
  Button: Button,
  Divider: Divider,
  Group: Group,
  Hero: Hero,
  Image: Image,
  Navbar: Navbar,
  NavbarLink: NavbarLink,
  Social: Social,
  SocialElement: SocialElement,
  Spacer: Spacer,
  Raw: Raw,
  Table: Table,
};
